import { keyframes } from "@mui/system";
export const transactionTypes = ["deposit", "payout", "withdrawal", "cashin"];
export const transactionStatuses = [
  "dispute",
  "completed",
  "canceled",
  "created",
];
/**
 * Цвета согласованы с семантической палитрой темы (success/error/warning/info).
 * `color` красит точку и подложку, `onLight`/`onDark` — подпись: один средний
 * тон не проходит 4.5:1 одновременно на белом и на почти чёрном.
 */
type StatusTone = {
  label: string;
  color: string;
  onLight: string;
  onDark: string;
};

export const statusMeta: Record<string, StatusTone> = {
  completed: {
    label: "Успешно",
    color: "#17A673",
    onLight: "#0C7951",
    onDark: "#5DD5A6",
  },
  canceled: {
    label: "Отменено",
    color: "#E5484D",
    onLight: "#B72D32",
    onDark: "#FF7A7E",
  },
  created: {
    label: "Создано",
    color: "#F5A524",
    onLight: "#8A5700",
    onDark: "#FFC967",
  },
  dispute: {
    label: "Спор",
    color: "#3E8BF3",
    onLight: "#2869C1",
    onDark: "#77B0FF",
  },
  form_opened: {
    label: "Форма открыта",
    color: "#F5A524",
    onLight: "#8A5700",
    onDark: "#FFC967",
  },
  processing: {
    label: "В обработке",
    color: "#F5A524",
    onLight: "#8A5700",
    onDark: "#FFC967",
  },
  confirmation: {
    label: "Подтверждение",
    color: "#F5A524",
    onLight: "#8A5700",
    onDark: "#FFC967",
  },
};

const unknownStatus: StatusTone = {
  label: "Неизвестно",
  color: "#667085",
  onLight: "#475467",
  onDark: "#AAB3CA",
};

/**
 * Безопасный доступ: бэкенд может прислать статус, которого нет в словаре.
 * Режим палитры даёт подпись, читаемую на текущей поверхности.
 */
export const getStatusMeta = (
  status?: string | null,
  mode: "light" | "dark" = "light",
) => {
  const meta =
    (status && statusMeta[status]) || { ...unknownStatus, label: status || "—" };
  return { ...meta, textColor: mode === "dark" ? meta.onDark : meta.onLight };
};

export const rotate360 = keyframes`
  0%   { transform: rotate(360deg); }
  100% { transform: rotate(0); }
`;
export const safeJsonParse = (value: any) => {
  if (!value) return {};

  try {
    return JSON.parse(value);
  } catch {
    return value;
  }
};
